export const MODULE_TREE = [
  { id: 'RosterMaintenance', label: 'Roster Maintenance', parent: '' },
];

export const TABS_DATA = [
  { id: 'RosterMaintenance', label: 'Roster Maintenance' },
];
